<template>
  <div class="view view-home">
    <top-bar v-if="isPortalReady" />
    <div class="container" v-show="this.user.mis_compras_moviles.length > 0">
      <div class="block_static">
        <div class="row" style="display: flex; align-items: center">
          <div class="col-sm-6">
            <div class="header_block_static">
              <span>Selecciona tu curso favorito</span>
              <div class="descripcion_block_static">
                <div>
                  Topclass es la plataforma latinoamericana que ofrece una nueva
                  y entretenida experiencia de aprendizaje online, a través
                  cursos dictados por reconocidos especialistas y celebridades,
                  de quienes aprenderás nuevos conocimientos a través de su
                  experiencia personal y profesional.
                </div>
                <div>
                  Podrás verlos en el horario que tú escojas, desde el lugar que
                  quieras y avanzar a tu ritmo.&nbsp;
                </div>
              </div>
              <br /><!---->
            </div>
          </div>
          <div class="col-sm-6 ocultar-movil">
            <div class="container">
              <div
                id="container-video-10"
                class="container-video"
                style="background-image: none"
              >
                <img
                  src="https://res.cloudinary.com/dmx3pf3os/image/upload/fl_lossy/v1549657452/galerias/dm64LnaHVW_mesa-de-trabajo-1png.png"
                />
                <div class="banner-content-video-movil"><!----></div>
                <div class="banner-content-home"><!----></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container" v-show="this.user.mis_compras_moviles.length <= 0">
      <div class="block_static">
        <div class="row" style="display: flex; align-items: center">
          <div class="col-sm-6">
            <div class="header_block_static">
              <span>Selecciona tu curso favorito</span>
              <div class="descripcion_block_static">
                <div>Cargando cursos <spinner class-name="color-red" />.</div>
              </div>
              <br /><!---->
            </div>
          </div>
          <div class="col-sm-6 ocultar-movil"></div>
        </div>
      </div>
    </div>

    <div class="container" v-show="this.user.mis_compras_moviles.length > 0">
      <div class="home-curso-list">
        <h3 class="home-curso-list-title">Cursos</h3>
        <curso-list
          :cursos="cursos"
          columnas="6"
          :show_curso="show_curso"
          @cursoClick="verCurso"
        />
      </div>
    </div>

    <b-modal
      v-model="isSelectCursoModalVisible"
      :busy="true"
      centered
      hide-footer
      title="Confirmar Suscripcion"
    >
      <div ref="transferencia-form-form text-center">
        <label>{{ this.cursoSelect.producto }}</label>

        <img
          class="curso-card-image"
          :src="
            typeof cursoSelect.foto_principal !== 'undefined' &&
            cursoSelect.foto_principal.includes('/fl_lossy/')
              ? cursoSelect.foto_principal
              : typeof cursoSelect.foto_principal !== 'undefined'
              ? cursoSelect.foto_principal
                  .replace('upload', 'upload/fl_lossy')
                  .replace('http:', 'https:')
              : ''
          "
        />

        <br /><br />
        <div class="form-group text-center" @click="ConfirmCurso">
          <button
            class="btn btn-primary w-100 btn-noradius"
            style="height: 45px"
          >
            Confirmar
          </button>
          <br /><br />

          <div
            class="text-center alert-text-box"
            v-if="this.isSelectCursoCheck || this.isSelectCursoMessage != ''"
          >
            <p v-if="this.isSelectCursoCheck">
              Confirmando <spinner class-name="color-red" />
            </p>
            <p v-if="this.isSelectCursoMessage != ''">
              {{ this.isSelectCursoMessage }}<br />
              Redireccionando <spinner class-name="color-red" />
            </p>
          </div>
        </div>
      </div>
    </b-modal>

    <site-footer v-if="isPortalReady" :verFooter="true" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import TopBar from "../components/TopBar";
import CursoList from "../components/CursoList";
import SiteFooter from "../components/SiteFooter";
import BlockStatic from "../components/BlockStatic";
import Countdown from "../components/Countdown";
import {
  getCategoriaDeProducto,
  getProductoDeCategoria,
  eventKlaviyo,
} from "../utilities/data";
import { wait } from "../utilities/util";
import Carousel from "../components/Carousel";
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import Spinner from "../components/Spinner";

import {
  faCheck,
  faSpinner,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "homeChangeMovil",
  components: {
    TopBar,
    CursoList,
    SiteFooter,
    Spinner,
    Carousel,
    BlockStatic,
    Countdown,
    bModal,
  },
  directives: {
    "b-modal": bModalDirective,
  },
  data() {
    return {
      banners: [],
      videosLoaded: false,
      playerRetryCount: 0,
      show_curso: 0,
      verFooter: false,
      isSelectCursoModalVisible: false,
      isSelectCursoCheck: false,
      isSelectCursoMessage: "",
      cursoSelect: {},
      categoriaSelect: {},
    };
  },
  watch: {
    isPortalReady(val, old) {
      if (val && !old && this.videosLoaded) {
        this.loadBanners();
      }
    },
    //ACTIVAR IMPRESION DE PRODUCTOS
    cursos(val, old) {
      let impression = [];
      val.forEach((curso) => {
        impression.push({
          name: curso.producto.producto, // Name or ID is required.
          id: curso.producto.id,
          price: curso.producto.precio,
          category: curso.categoria.categoria,
          list: "Home",
          position: curso.categoria.posicion,
        });
      });
      dataLayer.push({
        event: "impressions",
        ecommerce: {
          currencyCode: "CLP",
          impressions: impression,
        },
      });
    },
  },
  computed: {
    cursos() {
      return this.portal.categorias
        .map((categoria) => {
          return {
            categoria,
            producto: getProductoDeCategoria(this.portal, categoria.id),
          };
        })
        .filter((producto) => producto.categoria !== false);
    },
    ...mapState(["portal", "user", "isPortalReady"]),
  },
  methods: {
    ConfirmCurso() {
      this.isSelectCursoCheck = true;

      this.user.mis_compras_moviles.forEach((compra) => {
        if (
          compra.estado_compra == "PAGADA_SUSCRITO" &&
          this.user.movistar_sat == "PENDIENTE"
        ) {
          this.$api
            .cambiar_curso_seleccionado({
              incriptionid: compra.incriptionid,
              id_producto: this.cursoSelect.id,
            })
            .then((response) => {
              console.log("RESPUESTA CONFIRMAR SUSCRIPCION MOVIL ", response);
              if (response.data.response == "200") {
                this.isSelectCursoMessage = "Suscripcion realizada con exito.";

                let newUserData = {
                  id_portal: this.portal.id,
                  name: this.user.name,
                  apellido: this.user.apellido,
                  email: this.user.email,
                  telefono: this.user.telefono,
                  direccion: this.user.direccion,
                  sexo: this.user.sexo,
                  fecha_nac: this.user.fecha_nac,
                  id_pais: this.portal.id_pais,
                  movistar_sat: "ACTIVO",
                  password: this.user.password,
                };

                this.$store
                  .dispatch("updateUser", newUserData)
                  .then((response) => {
                    window.location.href =
                      "/curso/" + this.categoriaSelect.guid;
                  });
              } else {
                this.isSelectCursoMessage = "Error realizando Suscripcion.";
              }

              this.isSelectCursoCheck = false;
            })
            .catch((error) => {
              console.log("error suscripcion ", error);

              this.isSelectCursoMessage = "Error realizando Suscripcion.";
              this.isSelectCursoCheck = false;
            });
        }
      });
    },
    scrollElement() {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight ===
          document.documentElement.offsetHeight;

        console.log(
          document.documentElement.scrollTop +
            " - " +
            window.innerHeight * (this.show_curso / 5) +
            " - " +
            document.documentElement.offsetHeight
        );

        if (
          document.documentElement.scrollTop >
          window.innerHeight * (this.show_curso / 5)
        ) {
          this.show_curso = this.show_curso + 6;

          console.log("CURSOS A MOSTRAR " + this.show_curso);

          this.verFooter = true;
        }
      };
    },
    toggleLoginModal(toggle) {
      this.$store.commit("togglePortalLoginModal", toggle);
    },
    toggleRegistroModal(toggle) {
      this.$store.commit("togglePortalRegistroModal", toggle);
    },
    verCurso(categoria, producto) {
      if (this.user.movistar_sat == "ACTIVO") {
        window.location.href = "/";
      }

      this.isSelectCursoModalVisible = true;
      this.cursoSelect = producto;
      this.categoriaSelect = categoria;
    },
  },
  created() {
    this.players = [];
  },
  mounted() {
    if (this.user.movistar_sat == "ACTIVO") {
      window.location.href = "/";
    }
  },
};
</script>
